import { useEffect, useRef, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { DownloadSimple, Printer, ShoppingCart } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";
import { guestUrl, khUrl } from "@/lib/api";

const NAVY = "#0E1729";
const LIGHT = "#F4F6F8";
export const CARD = [1011, 638];
export const TAG = [520, 760];

function rr(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.roundRect(x, y, w, h, r);
}

function house(ctx, x, y, s, fg, hole) {
  const k = s / 64;
  ctx.fillStyle = fg;
  ctx.beginPath();
  ctx.moveTo(x + 32 * k, y + 13 * k);
  ctx.lineTo(x + 51 * k, y + 30 * k);
  ctx.lineTo(x + 51 * k, y + 51 * k);
  ctx.lineTo(x + 13 * k, y + 51 * k);
  ctx.lineTo(x + 13 * k, y + 30 * k);
  ctx.closePath();
  ctx.fill();
  ctx.fillStyle = hole;
  ctx.beginPath();
  ctx.arc(x + 32 * k, y + 34.5 * k, 5.2 * k, 0, Math.PI * 2);
  ctx.fill();
  ctx.beginPath();
  ctx.moveTo(x + 29.6 * k, y + 36.5 * k);
  ctx.lineTo(x + 28 * k, y + 45.5 * k);
  ctx.lineTo(x + 36 * k, y + 45.5 * k);
  ctx.lineTo(x + 34.4 * k, y + 36.5 * k);
  ctx.fill();
}

function fitText(ctx, text, max, size, weight = 600) {
  let s = size;
  do { ctx.font = `${weight} ${s}px Outfit`; s -= 2; } while (ctx.measureText(text).width > max && s > 20);
}

export function drawCard(c, name, qr) {
  const ctx = c.getContext("2d");
  const [W, H] = CARD;
  ctx.clearRect(0, 0, W, H);
  rr(ctx, 0, 0, W, H, 48);
  ctx.fillStyle = NAVY;
  ctx.fill();
  house(ctx, 52, 44, 96, LIGHT, NAVY);
  ctx.fillStyle = LIGHT;
  ctx.font = "700 46px Outfit";
  ctx.textBaseline = "middle";
  ctx.fillText("hostkey", 156, 95);
  const w = ctx.measureText("hostkey").width;
  ctx.font = "300 46px Outfit";
  ctx.fillText(".online", 156 + w, 95);
  ctx.textBaseline = "alphabetic";
  ctx.fillStyle = "rgba(244,246,248,.7)";
  ctx.font = "600 26px Outfit";
  ctx.letterSpacing = "6px";
  ctx.fillText("WELCOME TO", 72, 410);
  ctx.letterSpacing = "0px";
  ctx.fillStyle = LIGHT;
  fitText(ctx, name || "Your Airbnb", 600, 64);
  ctx.fillText(name || "Your Airbnb", 72, 488);
  ctx.fillStyle = "rgba(244,246,248,.8)";
  ctx.font = "400 30px DM Sans";
  ctx.fillText("Tap your phone here to check in", 72, 548);
  rr(ctx, W - 72 - 230, H - 72 - 230, 230, 230, 22);
  ctx.fillStyle = "#FFFFFF";
  ctx.fill();
  if (qr) ctx.drawImage(qr, W - 72 - 215, H - 72 - 215, 200, 200);
}

export function drawTag(c, label, qr) {
  const ctx = c.getContext("2d");
  const [W, H] = TAG;
  ctx.clearRect(0, 0, W, H);
  rr(ctx, 0, 0, W, H, 210);
  ctx.fillStyle = "#E9ECF0";
  ctx.fill();
  ctx.fillStyle = "#FFFFFF";
  ctx.beginPath();
  ctx.arc(W / 2, 80, 30, 0, Math.PI * 2);
  ctx.fill();
  ctx.strokeStyle = "#C9CED6";
  ctx.lineWidth = 4;
  ctx.stroke();
  const cx = W / 2;
  ctx.strokeStyle = NAVY;
  ctx.lineWidth = 22;
  ctx.lineCap = "round";
  ctx.lineJoin = "round";
  ctx.beginPath();
  ctx.moveTo(cx - 125, 290);
  ctx.lineTo(cx, 180);
  ctx.lineTo(cx + 125, 290);
  ctx.stroke();
  rr(ctx, cx - 82, 250, 164, 150, 16);
  ctx.fillStyle = NAVY;
  ctx.fill();
  ctx.fillStyle = "#E9ECF0";
  ctx.beginPath();
  ctx.arc(cx, 305, 20, 0, Math.PI * 2);
  ctx.fill();
  ctx.beginPath();
  ctx.moveTo(cx - 9, 318);
  ctx.lineTo(cx - 16, 372);
  ctx.lineTo(cx + 16, 372);
  ctx.lineTo(cx + 9, 318);
  ctx.fill();
  ctx.fillStyle = NAVY;
  ctx.textAlign = "center";
  ctx.font = "700 40px Outfit";
  ctx.letterSpacing = "8px";
  ctx.fillText("TAP HERE", cx + 4, 470);
  ctx.letterSpacing = "0px";
  rr(ctx, cx - 95, 510, 190, 190, 18);
  ctx.fillStyle = "#FFFFFF";
  ctx.fill();
  if (qr) ctx.drawImage(qr, cx - 82, 523, 164, 164);
  ctx.fillStyle = "#5B6470";
  fitText(ctx, label, 360, 26, 500);
  ctx.textAlign = "left";
  if (label) { ctx.textAlign = "center"; ctx.fillText(label, cx, 735); ctx.textAlign = "left"; }
}

export const save = (c, name) => {
  const a = document.createElement("a");
  a.href = c.toDataURL("image/png");
  a.download = name;
  a.click();
};

function printCanvas(c, mm = "85.6mm") {
  const w = window.open("", "_blank");
  if (!w) return;
  w.document.write(`<html><body style="margin:0;display:grid;place-items:center;min-height:100vh"><img src="${c.toDataURL("image/png")}" style="width:${mm}" onload="setTimeout(()=>{window.print()},200)"/></body></html>`);
  w.document.close();
}

export function PrintKit({ property, keyholders }) {
  const name = property.data.name;
  const nav = useNavigate();
  const order = (kind) => {
    const isKh = kind === "keyholder" && kh !== "main";
    nav("/dashboard/orders", { state: { design: { kind, property_id: property.property_id, kh_id: isKh ? kh : null, property_name: name, label: isKh ? khDoc?.label : "Main guest link" } } });
  };
  const [kh, setKh] = useState("main");
  const cardRef = useRef();
  const tagRef = useRef();
  const qrCardRef = useRef();
  const qrTagRef = useRef();
  const khDoc = keyholders.find((k) => k.kh_id === kh);
  const tagUrl = khDoc ? khUrl(khDoc.code) : guestUrl(property.slug);

  useEffect(() => {
    let live = true;
    document.fonts.ready.then(() => {
      if (!live) return;
      drawCard(cardRef.current, name, qrCardRef.current?.querySelector("canvas"));
      drawTag(tagRef.current, khDoc ? khDoc.label : name, qrTagRef.current?.querySelector("canvas"));
    });
    return () => { live = false; };
  }, [name, tagUrl, khDoc]);

  const btn = "inline-flex h-9 items-center gap-1.5 rounded-lg border border-border px-3 text-sm font-semibold transition-colors duration-200 hover:border-[#0E1729]";
  return (
    <section className="rounded-2xl border border-border bg-white p-6" data-testid="print-kit">
      <h3 className="font-display text-lg">Printable card & key holder</h3>
      <p className="mt-1 text-sm text-muted-foreground">Print-ready designs with your property name and QR code. Download them for your printer, or order them ready-made from Order cards.</p>
      <div className="hidden" ref={qrCardRef}><QRCodeCanvas value={guestUrl(property.slug)} size={400} marginSize={1} /></div>
      <div className="hidden" ref={qrTagRef}><QRCodeCanvas value={tagUrl} size={400} marginSize={1} /></div>
      <div className="mt-5 grid items-start gap-6 md:grid-cols-[1.6fr,1fr]">
        <div>
          <canvas ref={cardRef} width={CARD[0]} height={CARD[1]} className="w-full rounded-[18px] shadow-[0_20px_40px_-20px_rgba(14,23,41,.5)]" data-testid="print-card-canvas" />
          <p className="mt-2 text-xs text-muted-foreground">NFC card · 85.6 × 54 mm</p>
          <div className="mt-3 flex gap-2">
            <button onClick={() => save(cardRef.current, `${name}-card.png`)} className={btn} data-testid="download-card-design"><DownloadSimple /> Download PNG</button>
            <button onClick={() => printCanvas(cardRef.current)} className={btn} data-testid="print-card-design"><Printer /> Print</button>
            <button onClick={() => order("card")} className={`${btn} border-[#D96C4A] bg-[#D96C4A] text-white hover:border-[#C25D3E]`} data-testid="order-card-design"><ShoppingCart /> Order this card</button>
          </div>
        </div>
        <div>
          <canvas ref={tagRef} width={TAG[0]} height={TAG[1]} className="mx-auto w-full max-w-[220px]" data-testid="print-tag-canvas" />
          <p className="mt-2 text-center text-xs text-muted-foreground">NFC key holder</p>
          <select value={kh} onChange={(e) => setKh(e.target.value)} data-testid="print-tag-link-select" className="mt-3 h-9 w-full rounded-lg border border-border bg-white px-2 text-sm">
            <option value="main">Main guest link</option>
            {keyholders.map((k) => <option key={k.kh_id} value={k.kh_id}>Key holder: {k.label}</option>)}
          </select>
          <div className="mt-2 flex justify-center gap-2">
            <button onClick={() => save(tagRef.current, `${khDoc ? khDoc.label : name}-keyholder.png`)} className={btn} data-testid="download-tag-design"><DownloadSimple /> PNG</button>
            <button onClick={() => printCanvas(tagRef.current, "40mm")} className={btn} data-testid="print-tag-design"><Printer /> Print</button>
          </div>
          <button onClick={() => order("keyholder")} className={`${btn} mt-2 w-full justify-center border-[#D96C4A] bg-[#D96C4A] text-white hover:border-[#C25D3E]`} data-testid="order-tag-design"><ShoppingCart /> Order this key holder</button>
        </div>
      </div>
    </section>
  );
}
